<div class="box-line">
  <div class="box"
       [class.vertical]="vertical">
    <div class="label"
         [translate]="labelKey"></div>

    <div class="middle-part">
      <ng-content select="[middle]"></ng-content>
    </div>

    <ng-content></ng-content>
  </div>
  <div class="aside-part">
    <ng-content select="[aside]"></ng-content>
  </div>
</div>
